import * as React from 'react'
import { FC, useCallback } from 'react'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

interface Props {
  label?: string
  filterValue?: string
  onChange: (status: string) => void
}

export const SoldServiceStatusSelect: FC<Props> = (props) => {
  const { label, onChange, filterValue } = props

  const handleFilterChange = useCallback(
    (e) => {
      const status = e.target.value
      onChange(status)
    },
    [onChange],
  )

  return (
    <FormControl variant="standard" fullWidth>
      {label && (
        <InputLabel id="sold-service-status-select-label">{label}</InputLabel>
      )}
      <Select
        labelId="sold-service-status-select-label"
        id="sold-service-status-select"
        data-test-id="sold-service-status-select"
        label={label}
        fullWidth
        value={filterValue}
        onChange={handleFilterChange}
      >
        <MenuItem value="ALL">All</MenuItem>
        <MenuItem value={SOLD_SERVICE_STATUS.Revise}>Revise</MenuItem>
        <MenuItem value={SOLD_SERVICE_STATUS.Submitted}>Submitted</MenuItem>
        <MenuItem value={SOLD_SERVICE_STATUS.Completed}>Completed</MenuItem>
        <MenuItem value={SOLD_SERVICE_STATUS.Processing}>Processing</MenuItem>
      </Select>
    </FormControl>
  )
}
